import ChessRestClient from '@/Api/ChessRestClient';

export type OtpResponse = {
  success: boolean;
  error?: string;
  retry_after_seconds?: number;
  message?: string;
};

function extractData(err: any): OtpResponse {
  if (err?.response?.data && typeof err.response.data === 'object') {
    return err.response.data as OtpResponse;
  }
  return {success: false, error: 'network_error'};
}

export async function sendEmailChangeOtp(newEmail: string): Promise<OtpResponse> {
  if (!newEmail?.trim()) return {success: false, error: 'invalid_email_format'};
  try {
    const response = await ChessRestClient.post('learning/send_email_change_otp/', {
      new_email: newEmail.trim().toLowerCase(),
    });
    return response?.data ?? {success: false, error: 'empty_response'};
  } catch (err) {
    return extractData(err);
  }
}

export async function verifyEmailChangeOtp(
  newEmail: string,
  otp: string,
): Promise<OtpResponse> {
  if (!newEmail?.trim() || !otp?.trim()) return {success: false, error: 'invalid_input'};
  try {
    const response = await ChessRestClient.post('learning/save_profile/', {
      email: newEmail.trim().toLowerCase(),
      email_change_otp: otp.trim(),
    });
    return response?.data ?? {success: false, error: 'empty_response'};
  } catch (err) {
    return extractData(err);
  }
}
